import React from 'react'
import LoadingBar from 'react-redux-loading-bar'
import withStyles from '@mui/styles/withStyles'

import QAPVars from 'qap/vars'

type Props = {
  classes: any;
};

const styles = {
  root: {
    zIndex: 9999,
    position: 'fixed',
    backgroundColor: QAPVars.pRDark,
    height: 3
  }
} as const

const Loading = ({
  classes,
}: Props) => (
  <LoadingBar className={classes.root} showFastActions />
)

export default withStyles(styles)(Loading)
